/* eslint-disable react/no-array-index-key */
import * as React from 'react'
import * as S from './styles'
import { HowItWorksColumn } from '@shared/interfaces/HowItWorks'
import HowItWorksItem from '@site/components/molecules/HowItWorksItem'
import { tagTheme } from '@taglivros/tag-components'


const HowItWorksList = ( { data, colorTitle }: HowItWorksList.Props ): React.ReactElement => {
  return (
    <S.UnorderedList className="how-it-works-list">
      {data &&
        data.map( ( item, index ) => {
          return (
            <HowItWorksItem
              imageAlt={ item.imageAlt }
              imagePath={ item.image }
              key={ String( index ) }
              secondaryText={ item.subtitle }
              title={ item.title }
              colorTitle={ colorTitle }
            />
          )
        } ) }
    </S.UnorderedList>
  )
}

namespace HowItWorksList {
  export interface Props {
    data: HowItWorksColumn[]
    colorTitle: keyof typeof tagTheme.cores
  }
}

export default HowItWorksList
